// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1qxOP","description":"PatientConsentPreview_description__3IgWn"};